import store from '@redux/store';
import { SberThemeProvider } from '@sberlab/core-components';
import './index.css'
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import AppRouter from './routes';

const App = (): JSX.Element => (
    <Provider store={store}>
        <SberThemeProvider>
            <Router>
                <AppRouter />
            </Router>
        </SberThemeProvider>
    </Provider>
);

export default App;
